module.exports = __webpack_public_path__ + "assets/img/4.3095e775.png";